"use client"

import { Global, css } from "@emotion/react"
import { usePathname } from "next/navigation"

// const HeeboFontFaces = css`
//   @font-face {
//     font-family: "Heebo";
//     src: url("/fonts/Heebo-Regular.ttf") format("truetype");
//     font-weight: normal;
//   }
//   @font-face {
//     font-family: "Heebo";
//     src: url("/fonts/Heebo-Medium.ttf") format("truetype");
//     font-weight: 500;
//   }

//   @font-face {
//     font-family: "Heebo";
//     src: url("/fonts/Heebo-Bold.ttf") format("truetype");
//     font-weight: bold;
//   }
// `

const GlobalStyle = () => {
  const pathname = usePathname()
  const isAdminRoute = pathname?.startsWith("/admin")

  return (
    <Global
      styles={css`
        :root {
          /* Font loaded via next/font in layout.tsx */
          font-family: var(--font-raleway), sans-serif;
          height: 100%;
        }
        body {
          height: 100%;
          ${!isAdminRoute &&
          css`
            overflow: hidden;
          `}
        }

        #__next {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        a {
          color: inherit;
          text-decoration: none;
        }
      `}
    />
  )
}

export default GlobalStyle
